import { useState, useEffect } from 'react'
import { RecruitsAeAPI } from '../services/recruit'
import { useSelector } from 'react-redux'

function UserecruitsAe(searchs) {
  const [data, setData] = useState([])
  const roleId = useSelector((state) => state.roleReducer.role)
  const orgId = roleId
  useEffect(() => {
    const param = {
      page: 1,
      size: 10,
      searchs
      // code: 'SK65050'
      // orgId
    }
    const getData = async () => {
      const result = await RecruitsAeAPI({ ...param, orgId })
      if (!result) return
      if (result.status) {
        if (result.result.length > 0) {
          const newData = result.result.map((d, i) => {
            return { label: d.rc_no, value: d.rc_no }
          })

          setData(newData)
        } else {
          setData([])
        }
      } else {
        setData([])
      }
    }

    if (searchs) {
      getData()
    } else {
      setData([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchs])

  return data
}

export default UserecruitsAe
